import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=6bc81e38&scoped=true"
import script from "./orderConfirm.vue?vue&type=script&lang=js"
export * from "./orderConfirm.vue?vue&type=script&lang=js"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=6bc81e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc81e38",
  null
  
)

export default component.exports